import "../../../css/product-details.scss";
import "../../../css/ribbon-labels.scss";
import { ICartHeaders } from "../../../global";
import { BreakpointFunction } from "../../Components/BreakpointFunctions";
import * as Carousel from '../../Components/CarouselScroll';
import { AlertModal } from "../../Components/index";
import "../../Globals/Extenders/TrackChange";
import { ListenEvent } from "../../Globals/index";
import { checkOverflow } from "../../Helpers/CheckElementOverflow";
import { checkURLValidity } from "../../Helpers/CheckURLValidity";
import { AutoFormatNumber, ParseDate, UrlSegments } from "../../Helpers/index";
import { WaitForElementToDisplay } from "../../Helpers/WaitForElementToDisplay";
import { DataLayerModelFactory, DataLayerTxItem } from "../../Services/DataLayer/index";
import { AjaxPost, IAjaxPostConfig } from "../../Services/index";
import AddToCartVM from "./Components/AddToCart";
import { RefreshModel } from "./Components/index";
import { ItemListModels, ItemRowModel } from "./Models/index";
import { KnockoutValidationSettings } from "../../Globals/KnockoutValidationSettings";

class EventListeners {
    static CarouselScroll = Carousel.clickCarouselScroll;
}

export class ItemGroupVM {

    private isLoading = ko.observable(true);
    private IsNew: boolean;
    private IsOnSale: boolean;
    private CallOutRibbon = () => {
        if (this.IsNew) {
            return "text-center new-item-alert";
        }
        if (this.IsOnSale) {
            return "text-center sale-alert";
        }
        else {
            return "text-center ribbon-alert";
        }
    }

    private Row = new ItemRowModel();
    private ItemRowModel: KnockoutObservableArray<any> = ko.observableArray([]);
    private AccessoryRowModel: KnockoutObservableArray<any> = ko.observableArray([]);
    private PopupImage = this.Row.PopupImage;
    private LoadPopupImage = this.Row.LoadPopupImage;
    private AddToContract = this.Row.AddToContract;
    private OnSale = this.Row.OnSale;
    private OnContract = this.Row.OnContract;
    private CarouselClick = (data, type) => {
        if (type !== "V") {
            console.debug("Not a video");
            this.PopupImage(data);
            this.LoadPopupImage(data);
            $("#imageModal").modal('show');
        }
        if (type === "V") {
            console.debug("Image link to video");
        }
    }
    private IsRx = this.Row.IsRx;
    private StockStatus = this.Row.StockStatus;
    private FormatNumber = AutoFormatNumber;
    private ContractItems: any[];
    private AlertModal = new AlertModal();
    private GetSelectionQty = this.Row.GetSelectionQty;
    private MatchUMQty = this.Row.MatchUMQty;
    private UpdateQty = this.Row.UpdateQty;
    private ArrayToUpdate = (itemID: string) => {
        let self = this;
        let accessoryIndex = self.AccessoryRowModel().findIndex((x => x.ItemID === itemID));
        let isAccessory = accessoryIndex !== -1 ? true : false;
        let arrayToUpdate = isAccessory === true ? self.AccessoryRowModel : self.ItemRowModel;
        return arrayToUpdate;
    }
    private AddToContractFunction = AddToCartVM.AddToContractFunction;
    private AddToCart = AddToCartVM.AddToCart;
    private LA_Alert = AddToCartVM.LA_Alert;
    private ItemsToAdd = ko.pureComputed(() => {
        let self = this;
        let array = [];
        if (self.ItemRowModel().length > 0)
            $.each(self.ItemRowModel(), function (i, item) {
                $.each(item.UoMPrices(), function (k, UoM) {
                    if (UoM.QtySelected.originalValue !== UoM.QtySelected()) {
                        UoM.Description = item.Description || item.ItemID;
                        UoM.AddToContract = item.AddToContract;
                        UoM.OnSale = item.OnSale;
                        UoM.OnContract = item.OnContract;
                        array.push(UoM)
                    }
                })
            })
        if (self.AccessoryRowModel().length > 0)
            $.each(self.AccessoryRowModel(), function (i, item) {
                $.each(item.UoMPrices(), function (k, UoM) {
                    if (UoM.QtySelected.originalValue !== UoM.QtySelected()) {
                        UoM.Description = item.Description;
                        UoM.AddToContract = item.AddToContract;
                        UoM.OnSale = item.OnSale;
                        UoM.OnContract = item.OnContract;
                        array.push(UoM)
                    }
                })
            })
        return array;
    }, this);

    public HiglightSelectedAltItem = (data) => {
        localStorage.setItem('LastSearchTerm', data.ItemID)
        window.open(data.ProductUrl);
    }

    private ItemsCount = ko.pureComputed(() => {
        let self = this
        let tally = 0;
        if (self.ItemsToAdd())
            tally = self.ItemsToAdd().length;
        return (tally > 1 ? tally.toString() + " Items Chosen" : tally == 0 ? "No Item Chosen" : "1 Item Chosen");
    }, this);

    private AddChoicesToCart = AddToCartVM.AddChoicesToCart;
    private RefreshModel = RefreshModel;
    private CheckWhichUoM = (arraysToUpdate) => {
        let self = this;
        function cleanItemRows(itemRows) {
            $.each(itemRows.UoMPrices(), function (j, uom) {
                if (uom.QtySelected()) {
                    if (itemRows.UMQtySelected() === uom.UMQty) {
                        itemRows.Quantity(uom.QtySelected());

                        itemRows.Quantity.setOriginalValue(uom.QtySelected());
                        uom.QtySelected.setOriginalValue(uom.QtySelected());

                    }
                }
                uom.QtySelected.isDirty(false);
            });
        }

        // Match what is in cart with what is on item list
        function UoMQtySelectMatch(item) {
            $.each(item.UoMPrices(), function (j, prices) {
                if (prices.QtySelected()) {

                    prices.IsInCart(true);
                    item.UMQtySelected(prices.UMQty);
                    self.GetSelectionQty(prices, item);
                }
                else {
                    item.UMQtySelected(item.DefaultUMQty);
                }
            });
            cleanItemRows(item);
        };

        return new Promise(function (resolve) {
            // Check UoM Selected in row data and match with the UI Selected UoM Price
            $.each(self.ItemRowModel(), function (i, row) {
                UoMQtySelectMatch(row);
            })
            if (self.AccessoryRowModel().length > 0) {
                $.each(self.AccessoryRowModel(), function (i, item) {
                    UoMQtySelectMatch(item);
                })
            }
            return resolve(true);
        });
    }

    private ApprovalType = new AddToCartVM().ApprovalType;
    private SelectedApprover = new AddToCartVM().SelectedApprover;
    private SelectApprover = new AddToCartVM().SelectApprover;
    private ContractPricingLevels = new AddToCartVM().ContractPricingLevels
    private AddressBook = new AddToCartVM().AddressBook;
    private Comment = new AddToCartVM().RestrictionComment;
    private CustName = new AddToCartVM().CustName;
    private CustPhone = new AddToCartVM().CustPhone;
    private CustEmail = new AddToCartVM().CustEmail;
    private AltItemsHtml = AddToCartVM.AltItemsHtml;
    private RestrictionItems = new AddToCartVM().RestrictionItems;
    private ShowRetrictionModal = new AddToCartVM().ShowRetrictionModal;
    private Videos: KnockoutObservableArray<any> = ko.observableArray([]);
    private Question: KnockoutObservable<string> = ko.observable(null);
    private FirstName: KnockoutObservable<string> = ko.observable(null);
    private IsPrivateQuestion: KnockoutObservable<string> = ko.observable(null);
    private InputLoading: KnockoutObservable<boolean> = ko.observable(false);
    private AskQuestion = () => {
        let self = this;
        let recNo = parseInt(UrlSegments(2).toString());
        if (!self.Question() || self.Question().toString().trim() === "") {
            self.AlertModal.Title("No question asked")
            self.AlertModal.Content("Question cannot be empty!");
            $('#alertModal').modal('show');
            return;
        }

        if (self.IsPrivateQuestion() === "null" || self.IsPrivateQuestion().toString().trim() === "") {
            self.AlertModal.Title("Select question privacy")
            self.AlertModal.Content("We post user questions and answers to help other customers like you!<br />"
                + " Choose <i>Yes</i> to ask anonymously.<br />"
                + " Choose <i>No</i> to publicly display your name with your question.");
            $('#alertModal').modal('show');
            return;
        }
        self.InputLoading(true);
        let request = {
            ItemGroupRecNo: recNo,
            Question: self.Question,
            FirstName: self.FirstName,
            PrivateUserQuestion: self.IsPrivateQuestion,
        }

        function AskQuestion(payload) {
            let ajaxPost: IAjaxPostConfig = {
                endpoint: '/products/ask-question/' + payload.ItemGroupRecNo,
                payload: JSON.stringify(ko.toJS(payload)),
                cbFunction: function (response) {
                    if (response.message === "Success: Question sent. ") {
                        const container = $(".floating-alert-container");
                        const template = container.find('.alert').first();
                        let msgAlert = template.first().clone();
                        msgAlert.prop('id', 'ask-question-alert');
                        msgAlert.find('span').first().text('Your question has been sent!');
                        msgAlert.insertBefore(template).show();
                    }
                    if (response.message.split(':')[0] === "Error") {
                    }
                }
            }

            return new Promise((resolve, reject) => {

                return new AjaxPost({
                    endpoint: '/products/ask-question/' + payload.ItemGroupRecNo,
                    payload: JSON.stringify(ko.toJS(payload)),
                    cbFunction: function (response) {
                        if (response.message === "Success: Question sent. ") {
                            const container = $(".floating-alert-container");
                            const template = container.find('.alert').first();
                            let msgAlert = template.first().clone();
                            msgAlert.prop('id', 'ask-question-alert');
                            msgAlert.find('span').first().text('Your question has been sent!');
                            msgAlert.insertBefore(template).show();
                        }
                        if (response.message.split(':')[0] === "Error") {
                        }
                        resolve(response);
                    },
                    errFunction: function (err) {
                        reject(err);
                    }
                });
            })
        }

        let init = true;
        if (init) {
            AskQuestion(request)
                .then(() => {
                    self.Question(null);
                    self.FirstName(null);
                    self.IsPrivateQuestion("null");
                    $("#privateQuestion option:selected").prop("selected", false);
                    $("#privateQuestion option:first").prop("selected", "selected");
                    self.InputLoading(false);
                    init = false;
                });
        }
    }

    private ItemListModel = new ItemListModels();
    private SelectedItem = this.ItemListModel.SelectedItem;
    private SupplyLists = this.ItemListModel.SupplyLists;
    private HasAnySupplyListItems;
    private AddToList = this.ItemListModel.AddToList;
    private CreateNewList = this.ItemListModel.CreateNewList;
    private LastRequestID: KnockoutObservable<number> = ko.observable(0);

    constructor(DataModel: any, HasAnySupplyListItems: Boolean, videos: any) {
        ko.validation.init(KnockoutValidationSettings, true);
        let self = this,
            ItemList: Array<any> = DataModel.Items,
            AccessoryList: Array<any> = DataModel.AccessoryItems,
            ProcessItemRows = function (row: any) {
                if (row.WebSiteDescription)
                    delete Object.assign(row, { ['Description']: row['WebSiteDescription'] })['WebSiteDescription'];
                row.ImageName != '' ? row.ItemImagePrimary = row.ImageName : row.ItemImagePrimary = null;
                row.ItemGroupRecNo = parseInt(UrlSegments()[2]);
                row.OnContract = ko.observable(row.OnContract);
                row.UoMPrices = ko.observableArray(row.UoMPrices);
                $.each(row.UoMPrices(), function (k, uom) {
                    uom.Display = ko.observable(row.UoMPrices()[k].Display);
                    uom.QtySelected = ko.observable(0).extend({ trackChange: true });
                    uom.IsInCart = ko.observable(false);
                    row.UoMPrices.splice(k, 1, uom);
                });
                row.Quantity = ko.observable(0).extend({ trackChange: true });
                row.Quantity.subscribe((qty) => {
                    $.each(row.UoMPrices(), (idx, obj) => {
                        if (obj.UMQty === row.UMQtySelected()) {
                            if (row.Quantity.isDirty()) {
                                obj.QtySelected(parseInt(qty));
                            }
                            if (row.Quantity() === 0 && obj.QtySelected.isDirty()) {
                                obj.QtySelected(parseInt(qty));
                            }
                        }
                    })
                });
                row.UoMSelected = ko.observable(row.UoMPrices()[0].UoM)
                row.UMQtySelected = ko.observable(row.UoMPrices()[0].UMQty);
                row.AddedToCart = ko.observable(false);
            };

        self.IsNew = DataModel.IsNew;
        self.AddToContract = DataModel.AddToContract;
        self.Videos(videos);
        ParseDate(ItemList, ItemList, ["ALERTOrgDate", "ALERTUpdateDate", "INFOEstShipDate"]);
        ParseDate(AccessoryList, AccessoryList, ["ALERTOrgDate", "ALERTUpdateDate", "INFOEstShipDate"]);
        if (ItemList !== null && ItemList.length > 0) {
            ItemList.forEach((row) => {
                ProcessItemRows(row);
                self.ItemRowModel().push(row);
            });
        }

        if (AccessoryList !== null && AccessoryList.length > 0) {
            AccessoryList.forEach((row) => {
                ProcessItemRows(row);
                self.AccessoryRowModel().push(row);
            });
        }
        self.HasAnySupplyListItems = HasAnySupplyListItems;

        // Event listeners
        AddToCartVM.EventListeners(self);
        ListenEvent.clickJumpToTop();
        // Carousel controls and event listeners
        new EventListeners.CarouselScroll();

        $(window).on('load', function () {
            $('.carousel').carousel('pause');
        });

        // Check if the carousel thumbnails scroll is required (thumbs overflow), hide if it isn't
        let hideCarouselScrollArrows = () => {
            let thumbsH = $('#thumbs-container-h').find('ul').first()[0],
                thumbsHContainer = $('#thumbs-container-h')[0];
            let thumbsV = $('#thumbs-container-v').find('ul').first()[0],
                thumbsVContainer = $('#thumbs-container-v')[0];

            if (thumbsH) {
                console.debug("Thumbs-H overflow: ", checkOverflow(thumbsH, thumbsHContainer, "x"));
                if (checkOverflow(thumbsH, thumbsHContainer, "x")) {
                    $('#scroll-arrow-left').removeClass('d-none').addClass('d-flex');
                    $('#scroll-arrow-right').removeClass('d-none').addClass('d-flex');
                    $('#thumbs-container-h').find('ul').first().removeClass('px-2')
                }
            }

            if (thumbsV) {
                console.debug("Thumbs-V overflow: ", checkOverflow(thumbsV, thumbsVContainer, "y"));
                if (checkOverflow(thumbsV, thumbsVContainer, "y")) {
                    $('#scroll-arrow-up').removeClass('d-none').addClass('d-flex');
                    $('#scroll-arrow-down').removeClass('d-none').addClass('d-flex');
                }
            }
        }

        $(() => {
            $('.preloader').hide();
            self.isLoading(false);
            WaitForElementToDisplay("#item-group", 1500, hideCarouselScrollArrows);
            let header: ICartHeaders = window.cartVM.header;

            // Subscribe to header updates
            let arraysToUpdate = [self.ItemRowModel, self.AccessoryRowModel];
            self.RefreshModel(header.CartItems(), arraysToUpdate)

            header.HeaderRequestID.subscribe((change) => {
                console.debug("Current header request id", ko.unwrap(self.LastRequestID()));
                console.debug("Header request id changed to", change);
                let diff = (change - self.LastRequestID()) !== 0;

                if (diff) {
                    self.RefreshModel(header.CartItems(), arraysToUpdate).then((success) => {
                        console.debug("Model refreshed with request id", header.HeaderRequestID());
                        self.LastRequestID(header.HeaderRequestID());
                        $('[data-toggle="tooltip"]').tooltip();
                    })
                }
            })

            if (DataModel.Videos?.length > 0) {
                const scrollToVidMobile = () => {
                    console.debug("Show videos for mobile");
                    $('.list-group-item').each((i, el) => { $(el).removeClass('active show').attr('aria-selected', 'false') });
                    $('.tab-pane').each((i, el) => { $(el).removeClass('active show') });
                    $('a[href="#videos-tab"]').addClass('active show').attr('aria-selected', 'true');
                    $('#videos-tab').addClass('active show');

                    window.location.href = "#videos-mobile";
                },

                    scrollToVidDesktop = () => {
                        console.debug("Show videos for desktop");
                        window.location.href = "#videos";
                    },

                    scrollToVideos = () => {
                        if (window.location.hash.substr(1) === "videos") {
                            console.debug("Video hash matched");
                            BreakpointFunction({
                                xxlFunc: scrollToVidDesktop,
                                xlFunc: scrollToVidDesktop,
                                lgFunc: scrollToVidDesktop,
                                mdFunc: scrollToVidMobile,
                                smFunc: scrollToVidMobile,
                                xsFunc: scrollToVidMobile
                            });
                        }
                    };

                const changeVideoPoster = (size: string) => {
                    let videoElementsContainer = $('.video-loop-item');
                    videoElementsContainer.each((i, element) => {
                        let video = ($(element).find('video').first())[0];
                        let src = ($(video).find('source').first().attr('src')).split('SD/')[1];
                        let filename = src.slice(0, -4)
                        console.debug(`Video element at index ${i} :`, { video, filename });
                        video.setAttribute("poster", "/Content/ProductImages/" + size + "/" + filename + ".jpg");
                    })
                }

                const videoPosterFunctions = {
                    xxlFunc: () => { changeVideoPoster("720x540") },
                    xlFunc: () => { changeVideoPoster("460x345") },
                    lgFunc: () => { changeVideoPoster("384x288") },
                    mdFunc: () => { changeVideoPoster("460x345") },
                    smFunc: () => { changeVideoPoster("340x255") },
                    xsFunc: () => { changeVideoPoster("460x345") }
                },

                    updateVideoPoster = () => { BreakpointFunction(videoPosterFunctions) };

                WaitForElementToDisplay("#item-group", 500, () => {
                    updateVideoPoster();
                    window.addEventListener('resize', updateVideoPoster);
                    scrollToVideos();
                });
            }
        })

        WaitForElementToDisplay("#productCarousel .image-container img", 300, () => {
            let cardsHeight = $("#productCarousel").height();
            $("#productCarousel").css("min-height", cardsHeight + "px");

            $(window).resize(function () {
                cardsHeight = $("#productCarousel").height();
                $("#productCarousel").css("min-height", cardsHeight + "px");
            })
        });

        // Last Search Term
        $(() => {
            let lastSearchTerm = localStorage.getItem('LastSearchTerm');

            if (lastSearchTerm) {
                $('.grid-row').find('span, small').not('.input-group-prepend, .input-group-append, .custom-field').each(function (i, element) {
                    if (!element) return;

                    let regex = new RegExp('\\S*((' + lastSearchTerm + '))\\S*', 'ig');
                    var content = $(element).text(),
                        replacement = content.replace(regex, function (str) {
                            return '<span class="search_found_match_Key">' + str + '</span>';
                        });

                    // if ($(element) != undefined) $(element).parent().parent().parent().parent()                    
                    //console.log("element Item Group DIv========", $("#" + lastSearchTerm) )
                    if ($("#" + lastSearchTerm) != undefined && $("#" + lastSearchTerm).length > 0) {
                        //$("#" + lastSearchTerm).removeClass("grid-row")
                        $("#" + lastSearchTerm).addClass("search_found_match")
                        $("#" + lastSearchTerm).addClass("border-top")
                        $("#" + lastSearchTerm).addClass("border-left")
                        $("#" + lastSearchTerm).addClass("border-right")
                    }

                    $(element).html(replacement);
                });
                localStorage.removeItem('LastSearchTerm');
            }
        });

        // Popper tooltips
        $(() => {
            $('[data-toggle="tooltip"]').tooltip();
        })

        // Select first UoM by default on DOM ready. 
        $(() => {
            self.ItemRowModel().forEach(function (item, index) {
                if (item.UoMPrices())
                    item.UMQtySelected(item.UoMPrices()[0].UMQty)
            })

            if (self.AccessoryRowModel().length > 0) {
                self.AccessoryRowModel().forEach(function (item, index) {
                    if (item.UoMPrices())
                        item.UMQtySelected(item.UoMPrices()[0].UMQty)
                })
            }
        });

        // Set placeholder image if video source not found on DOM ready.
        $(() => {
            let vids = document.querySelectorAll("video");

            // for all the videos in the page
            for (var x = 0; x < vids.length; x++) {

                // add an event listening for errors
                vids[x].addEventListener('error', function (e) {

                    // if the error is caused by the video not loading
                    if (this.networkState > 2) {

                        // add an image with the message "video not found"
                        this.setAttribute("poster", "http://dummyimage.com/459x344/000/fff.jpg&text=Video+Not+Found");
                    }
                }, true);
            }
        })

        // Set placeholder image if video thumbnails not found after all ajax calls are complete.
        let vidThumbs = (() => {
            $('.video-thumbs').each((i, el) => {
                let imgUrl = $(el).attr('src');
                if (!checkURLValidity(imgUrl)) {
                    $(el).attr('src', '/Content/img/sprites/video-icon.svg');
                }
                if (!checkURLValidity(imgUrl)) {
                    $(el).attr('src', imgUrl);
                }
            });
        });

        $(document).ajaxComplete(() => { vidThumbs(); })

        // Reset carousel videos on slide change
        let resetVid = (() => {
            $('#slideshow').find('video').each((i, el: HTMLVideoElement) => {
                let vid: HTMLVideoElement = $(el).get(0);
                let vidTime = vid.currentTime;
                if (!vid.paused) {
                    vid.pause();
                    vidTime = 0;

                    console.debug("Video playback stopped: ", [vid, vidTime]);
                }
            })
        });

        $('#slideshow').bind('slide.bs.carousel', (() => { resetVid() }));
        $(document).ajaxComplete((event, xhr, options) => {
            console.debug("options.url: ", options.url);
            if (options.url.includes("GetProductsForPurchaseSelection_byItemGroupRecNo")) {
            }
        })

        // Analytics data layer implementation
        $(() => {

            let Model: any = DataModel;
            let Items: any[] = Model.Items;
            let AccessoryItems: any[] = Model.AccessoryItems;
            let dataLayerItems: any[] = Items ? Items.concat(AccessoryItems) : null;

            let products = [];
            console.log()
            if (dataLayerItems?.length) {

                if (dataLayerItems != null && dataLayerItems.length != 0) {
                    products = dataLayerItems.map((obj, index) => {
                        if (obj != null) {
                            return {
                                brand: obj.VendName,
                                id: obj.ItemID,
                                category: obj.Description,
                                name: obj.SDname,
                                // take the first UoM 
                                price: obj.UoMPrices()[0].Price,
                                variant: obj.UoMPrices()[0].UoM,
                                position: index
                            }
                        }
                    });
                }
            }

            let analytics = new DataLayerModelFactory().impressions(products, "productView", "Item Group Product View");

            if (analytics.ecommerce.impressions.length) {
                window.dataLayer.push(analytics);
            }

            $('.fa-cart-plus').not('.multiupdate').parent().on('click', function () {
                let itemID = $(this).attr('data-id');
                let UoM = $('#' + itemID).find('label.item-price.active').attr('data-uom');
                let price = parseFloat($('#' + itemID).find('label.item-price.active').attr('data-price'));
                let vm = window.vm;
                let product: DataLayerTxItem = new DataLayerTxItem();

                Object.assign(product, products.find(function (item) {
                    return item.id === itemID;
                }));
                let allProducts = vm.ItemRowModel().concat(vm.AccessoryRowModel());
                let originalItem = Object.assign({}, allProducts.find(function (item) {
                    return item.ItemID === itemID;
                }));

                product.variant = UoM;
                product.price = price.toFixed(2);

                let diff = 0;
                if (originalItem.Quantity != undefined) {
                    diff = originalItem.Quantity() - originalItem.Quantity.originalValue;
                }

                delete product.position;

                if (diff > 0) {
                    product.quantity = Math.abs(diff);
                    console.debug("Item added: ", product);
                    window.dataLayer.push(new DataLayerModelFactory().addToCart(product));
                }
                if (diff < 0) {
                    product.quantity = ~diff + 1;
                    console.debug("Item removed: ", product);
                    window.dataLayer.push(new DataLayerModelFactory().removeFromCart(product));
                }
            });
        })

        $(".siteloader").hide();
        $("#itemContainer").removeClass("d-none");
        $("#itemContainerMobile").removeClass("d-none");
        if (ItemList?.length > 0) {
            $("#items-tab").removeClass("d-none");
            $("#items-tab").addClass("active");
        }
        if (AccessoryList?.length > 0) {
            $("#accessories-tab").removeClass("d-none");
            $("#accessories-tab").addClass("active");
        }
    }
}